import { useState, useCallback } from "react";
import {
  ModalStep,
  JobStep,
  UseJobModalStepsReturn,
} from "../types/add-job.types";

export const useJobModalSteps = (
  initialStep: ModalStep = 1,
  initialJobStep: JobStep = "Existing"
): UseJobModalStepsReturn => {
  const [modalStep, setModalStep] = useState<ModalStep>(initialStep);
  const [jobStep, setJobStep] = useState<JobStep>(initialJobStep);

  const handleNextStep = useCallback(() => {
    if (modalStep === 1) {
      setModalStep(2);
    } else if (modalStep === 2) {
      setModalStep(3);
    }
  }, [modalStep]);

  const handleBackStep = useCallback(() => {
    if (modalStep === 2) {
      setModalStep(1);
    } else if (modalStep === 3) {
      setModalStep(2);
    }
  }, [modalStep]);

  return {
    modalStep,
    jobStep,
    setModalStep,
    setJobStep,
    handleNextStep,
    handleBackStep,
  };
};



